import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_CLASSES: 'fetchClasses',
  SET_CLASS: 'setClass',
  SET_PAGINATION: 'setPagination'
}

export const globalActions = getNamespacedBy('class', actionTypes)
